import { render, staticRenderFns } from "./SlideshowAdd.vue?vue&type=template&id=8f38233e&scoped=true"
import script from "./SlideshowAdd.vue?vue&type=script&lang=js"
export * from "./SlideshowAdd.vue?vue&type=script&lang=js"
import style0 from "./SlideshowAdd.vue?vue&type=style&index=0&id=8f38233e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f38233e",
  null
  
)

export default component.exports